import { render, staticRenderFns } from "./HomeBackButton.vue?vue&type=template&id=3e124821&scoped=true&"
import script from "./HomeBackButton.vue?vue&type=script&lang=js&"
export * from "./HomeBackButton.vue?vue&type=script&lang=js&"
import style0 from "./HomeBackButton.vue?vue&type=style&index=0&id=3e124821&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e124821",
  null
  
)

export default component.exports